import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { SavingsPlan } from "@models/savings_plan";
import { SAVINGS_WIDGET_ITEM_LIMIT } from "@helpers/constants";
import { SavingsHandlerComponent } from "../savings-handler.component";
import { StockTestService } from "@main-services/stock-test.service";
import { AccountService } from "../../../account/services/account.service";
import { SavingsService } from "@main-services/savings.service";
import { UserService } from "@main-services/user.service";
import { StockTestHelperService } from "@main-services/stock-test-helper.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { BehaviorSubject, combineLatest } from "rxjs";
import { ActivatedRoute } from "@angular/router";

@UntilDestroy()
@Component({
	selector: "savings-widget",
	templateUrl: "./savings-widget.component.html",
	styleUrls: ["./savings-widget.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class SavingsWidgetComponent extends SavingsHandlerComponent implements OnInit {
	// TODO: Refactor this widget-view, should use a proper view-model
	public showSavingsList$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	public constructor(
		protected tradableWalletListService: TradableWalletListService,
		protected modalService: ModalService,
		protected savingsService: SavingsService,
		protected accountService: AccountService,
		protected userService: UserService,
		protected stockTestService: StockTestService,
		protected stockTestHelperService: StockTestHelperService,
		private route: ActivatedRoute
	) {
		super(
			tradableWalletListService,
			modalService,
			savingsService,
			accountService,
			userService,
			stockTestService,
			stockTestHelperService
		);
	}

	// Widget only handles widget specific state, instantiates and updates widget item list
	public ngOnInit(): void {
		combineLatest([this.route.params, this.savingsService.getList()])
			.pipe(untilDestroyed(this))
			.subscribe(([params, list]) => this.setPlansForWidget(params["assetId"]));
	}

	// Widget on dashboard and on asset-detail pages
	private setPlansForWidget(assetId: string = ""): void {
		let filteredPlans: SavingsPlan[] = [...this.savingsService.activePendingPlans];
		if (assetId.length > 0) {
			filteredPlans = filteredPlans.filter((plan) => plan.getCurrencyId() === assetId);
		}
		this.sortPlansForWidget(filteredPlans);
		this.savingsService.setPlansForWidget(filteredPlans.slice(0, SAVINGS_WIDGET_ITEM_LIMIT));
		this.showSavingsList$.next(this.hasPlans());
	}

	public sortPlansForWidget(plans: SavingsPlan[]): SavingsPlan[] {
		return plans.sort((p1, p2) => {
			// Sort by next buy date:
			if (p1.getNextTradeAt().getDate() < p2.getNextTradeAt().getDate()) {
				return -1;
			}
			if (p1.getNextTradeAt().getDate() > p2.getNextTradeAt().getDate()) {
				return 1;
			}
			return 0;
		});
	}

	private hasPlans(): boolean {
		return this.savingsService.getUserHasSavingsPlan(!!this.tradable) && !this.savingsDisabled;
	}
}
